<template>
  <div>
    <b-row>
      <b-col sm="12">
        <div class="component-margin-half">
          <database-filter
            :recordCount = "recordCount"
            @changeFreeWordFilter="($event) => freeFilter=$event"
            @changeAsinFilter="($event) => asinFilter=$event"
            @changeFormFilter="($event) => formFilter=$event"
            @selectedMaterial="($event) => materialFilter=$event"
            @changeStatusFilter="($event) => statusFilter=$event"
            @filterSearch="getInvoiceProductMasterWithFilter()"
            @selectedCategory="($event) => invoiceCategoryId=$event"
            @selectedMaker="($event) => makerId=$event"
            @outputFileAll="getInvoiceProductCsvAll()"
            @outputFile="outputCsv()"/>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <!-- <b-col md="12">
        <merchandise-management-summary :items="filteredItems" :isShortItemName="isShortItemName" @changeItemNameToShort="changeItemNameToShort" />
      </b-col> -->
    </b-row>
    <b-row>
      <b-col sm="12" class="">
        <!-- <b-button size="sm" @click="editModal(null)" variant="danger">新規登録</b-button> -->
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table show-empty stacked="sm" bordered=true striped=true small=true hover=true
                :items="items" :fields="fields"
                :current-page="currentPage" :per-page="perPage"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
          <template slot="registeredDate" slot-scope="row"><label>{{formatDate(row.value)}}</label></template>
          <template slot="productImageUrl" slot-scope="row"><b-img class="image" :src="row.value"></b-img></template>
          <template slot="includeLithiumBattery" slot-scope="row">
            <b-checkbox size="sm" v-model="row.value" disabled></b-checkbox>
          </template>
          <template slot="category" slot-scope="row">
            <div><label class="mark bkcolor-red">英</label> {{row.item['dcategoryName']}}</div>
            <div><label class="mark bkcolor-darkblue">日</label> {{row.item['dcategoryNameJp']}}</div>
            <div><label class="mark bkcolor-blue">参考：<span>{{row.item['categoryNameAmazon']}}</label></div>
          </template>
          <template slot="makerAddress" slot-scope="row">
            <div>{{row.item['makerAddress']}}</div>
            <div><label class="mark bkcolor-blue">参考：<span>{{row.item['brand']}}</label></div>
          </template>
          <template slot="form" slot-scope="row">
            <div><label>{{row.item['dformMainName']}}</label></div>
            <div><label class="mark bkcolor-red">自</label>{{row.item['dformAutoName']}}</div>
            <div><label class="mark bkcolor-darkblue">手</label>{{row.item['dformManualName']}}</div>
            <div v-if="row.item['unavailableFormAuto']"><label class="mark bkcolor-dark">※自動無効</label></div>
          </template>
          <template slot="material" slot-scope="row">
            <div><label>{{row.item['dmaterialMainName']}}</label></div>
            <div><label class="mark bkcolor-red">自</label>{{row.item['dmaterialAutoName']}}</div>
            <div><label class="mark bkcolor-darkblue">手</label>{{row.item['dmaterialManualName']}}</div>
          </template>
          <template slot="status" slot-scope="row">
            <div v-for='(value, index) in row.item.statusMessage' :key='index'>
              {{ value }}
            </div>
          </template>
          <template slot="update" slot-scope="row">
            <b-button size="sm" @click="editModal(row)" variant="warning">更新</b-button>
          </template>
          <!-- <template slot="delete" slot-scope="row">
            <b-button size="sm" @click="deleteRowConfirm(row)" variant="secondary">削除</b-button>
          </template> -->
          <template slot="includeLithiumBattery" slot-scope="row">
            <b-checkbox size="sm" class="matome-status-mark" v-model="row.value" disabled></b-checkbox>
          </template>
        </b-table>
      </b-col>
      <b-modal ref="deleteRowConfirm" @ok="deleteRow" hide-header>
        <div class="text-center">{{confirmMessage}}</div>
      </b-modal>
      <b-modal ref="editModal" title="データベース登録" @ok="handleOk">
        <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="ASIN" label-for="asin">
          <b-form-input size="sm" id="asin" v-model="editItem.asin" disabled type="text"/>
        </b-form-group>
        <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="登録日" label-for="registeredDate">
          <b-form-input size="sm" id="registeredDate" v-model="editItem.registeredDate" disabled type="text"/>
        </b-form-group>
        <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="カテゴリ" label-for="categoryName">
          <category-search :categoryName="editItem.dcategoryName" :categoryWarningMessage="editItem.categoryWarningMessage" @selectedCategory="($event) => editItem.categoryId=$event" @selectedCategoryName="($event) => editItem.dcategoryName=$event" />
        </b-form-group>
        <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="商品名" label-for="productNameOrg">
          <b-form-input size="sm" id="productNameOrg" v-model="editItem.productNameOrg" type="text"/>
        </b-form-group>
        <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="リチウム" label-for="makerAddrCity">
          <b-checkbox size="sm" class="check-mark" v-model="editItem.includeLithiumBattery"></b-checkbox>
        </b-form-group>
        <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="フォーム(自)無効" label-for="unavailableFormAuto">
          <b-checkbox size="sm" class="check-mark" v-model="editItem.unavailableFormAuto"></b-checkbox>
        </b-form-group>
        <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="フォーム(手)" label-for="formManual">
          <b-form-select size="sm" id="formManual" v-model="editItem.formIdManual" :options="invoiceFormTypes"/>
        </b-form-group>
        <!-- <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="材料(手)" label-for="materialManual">
          <b-form-select size="sm" id="materialManual" v-model="editItem.materialManual" :options="invoiceMaterialTypes"/>
        </b-form-group> -->
        <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="材質(手)" label-for="materialName">
          <material-search :materialName="editItem.dmaterialManualName" @selectedMaterial="($event) => editItem.materialManual=$event" @selectedMaterialName="($event) => editItem.dMaterialManualName=$event" />
        </b-form-group>
        <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="メーカー" label-for="maker">
          <maker-search :makerName="editItem.dmakerName" :makerAddress="editItem.makerAddress" :dispAddress="true" :dispRegistButton="true" @registerMakerButton="dispMakerPopup()" @selectedMaker="($event) => editItem.makerId=$event" @selectedMakerName="($event) => editItem.dmakerName=$event" @selectedMakerAddress="($event) => editItem.makerAddress=$event"/>
        </b-form-group>
      </b-modal>
      <b-modal ref="registerMakerMaster" title="メーカーマスタ登録" @ok="registerMakerMaster">
        <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="メーカー名" label-for="newMakerName">
          <b-form-input size="sm" id="newMakerName" v-model="newMakerName" type="text"/>
        </b-form-group>
        <b-form-group size="sm" label-cols-sm="4" label-align-sm="right" label="住所" label-for="newMakerAddress">
          <b-form-input size="sm" id="newMakerAddress" v-model="newMakerAddress" type="text"/>
      </b-modal>
      <b-modal ref="confirmMessage" ok-only hide-header>
        <div class="text-center"><label>{{confirmMessageOkOnly}}</label></div>
      </b-modal>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-pagination :total-rows="recordCount" :per-page="perPage" v-model="currentPage"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import DatabaseFilter from '@/components/invoice/DatabaseFilter';
import * as api from '@/api';
import SearchCategory from '@/components/invoice/SearchCategory';
import SearchMaker from '@/components/invoice/SearchMaker';
import SearchMaterial from '@/components/invoice/SearchMaterial';
import InvoiceFormType from '@/types/InvoiceFormType';
import InvoiceMaterialType from '@/types/InvoiceMaterialType';
// import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  props: {
    editable: {
      default: false,
    },
    version: {
      default: 1,
    },
    isUpdate: {
      default: false,
    }
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'asin',   label: 'ASIN',   sortable: true, variant: 'base', class: 'table-lw8' },
        { key: 'registeredDate',   label: '登録日',   sortable: true, variant: 'base', class: 'table-lw6' },
        { key: 'productImageUrl', label: '画像', sortable: false, variant: 'base', class: 'table-cw4' },
        { key: 'productName',   label: '商品名',   sortable: true, variant: 'base'},
        { key: 'category',   label: 'Category',   sortable: true, variant: 'warning', class: 'table-lw10' },
        { key: 'form',   label: 'フォーム',   sortable: true, variant: 'warning', class: 'table-lw9' },
        { key: 'material',   label: '材料',   sortable: true, variant: 'warning', class: 'table-lw9' },
        // { key: 'dmakerName',   label: 'メーカー',   sortable: true, variant: 'warning', class: 'table-lw12'  },
        { key: 'makerAddress',   label: 'メーカー住所',   sortable: true, variant: 'warning', class: ''  },
        { key: 'dhscode',   label: 'HSコード',   sortable: true, variant: 'warning', class: 'table-lw7' },
        // { key: 'dcustomRate',   label: '関率',   sortable: true, variant: 'warning', class: 'table-rw4' },
        { key: 'includeLithiumBattery',   label: 'Lithium',   sortable: true, variant: 'warning', class: 'table-rw4' },
        { key: 'status',   label: 'Status',   sortable: true, variant: 'success', class: 'table-lw8' },
        { key: 'markCable',   label: 'Ca',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'markVideo',   label: 'Vi',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'markTsca',   label: 'Ts',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'markLacey',   label: 'La',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'markWatch',   label: 'Wa',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'markTscaLacey',   label: 'Tl',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'markClock',   label: 'Cl',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'markRadec',   label: 'Ra',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'markDrop',   label: 'Dr',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'update',   label: '更新',   sortable: true, variant: 'success', class: 'table-cw4' },
        // { key: 'delete',   label: '削除',   sortable: true, variant: 'success', class: 'table-cw4' },
      ],
      currentPage: 1,
      perPage: 100,
      totalRows: 0,
      sortBy: 'categoryName',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      editItem: {},
      confirmMessage: '',
      confirmMessageOkOnly: '',
      freeFilter: '',
      asinFilter: '',
      formFilter: '0',
      materialFilter: '0',
      invoiceCategoryId: 0,
      makerId: 0,
      statusFilter: '1',
      recordCount: 0,
      newMakerName: '',
      newMakerAddress: '',
      invoiceFormTypes: InvoiceFormType.values(),
      invoiceMaterialTypes: InvoiceMaterialType.values()
    };
  },
  created() {
    api.getInvoiceProductMaster(this.asinFilter, this.formFilter, this.materialFilter, this.invoiceCategoryId, this.makerId, this.statusFilter, this.freeFilter, (data) => {
      this.items = data.productMasterList;
      this.recordCount = this.items.length;
      this.addCellVariant(this.items);
    });
  },
  computed: {
    filteredItems() {
        let filteredItems = this.items.filter(item => {
         return (this.freeFilter === '' || (item.asin !== null && item.asin.toUpperCase().indexOf(this.freeFilter.toUpperCase()) !== -1));
        });
      // this.summaryItems = filteredItems;
      this.recordCount = filteredItems.length;
      this.currentPage = 1;
      // this.$emit('changeTotalRows', this.totalRows);
      return filteredItems;
    },
  },
  methods: {
    editModal(row) {
      this.editItem = {};
      this.updateItem = false;
      if (row !== null) {
        this.editItem =  Object.assign({}, this.editItem , row.item);
        this.updateItem = true;
      }
      this.$refs.editModal.show();
    },
    dispMakerPopup(){
      this.newMakerName = '';
      this.newMakerAddress = '';
      this.$refs.registerMakerMaster.show();
    },
    registerMakerMaster(){
      api.registerMakerMasterInInvoiceProduct(this.newMakerName, this.newMakerAddress, (data) => {
        this.$refs.registerMakerMaster.hide();
        this.editItem.makerId = data.makerId;
        this.editItem.dmakerName = data.makerName;
        this.editItem.makerAddress = data.makerAddress;
      });
    },
    getInvoiceProductMasterWithFilter(){
      api.getInvoiceProductMaster(this.asinFilter, this.formFilter, this.materialFilter, this.invoiceCategoryId, this.makerId, this.statusFilter, this.freeFilter, (data) => {
        this.items = data.productMasterList;
        this.recordCount = this.items.length;
        this.addCellVariant(this.items);
      });
    },
    getInvoiceProductCsvAll() {
      api.getInvoiceProductCsvAll((data) =>{
        // Invoiceをダウンロードする
        if(data.invoiceUrl != null && data.invoiceUrl !== ''){
          this.outputInvoiceData(data.invoiceUrl);
        }
      });
    },
    outputInvoiceData(invoiceUrl){
        let anchor = document.createElement('a');
        anchor.href = invoiceUrl;
        anchor.target = '_blank';
        anchor.click();
    },
    outputCsv() {
      let header = '\ufeff' + 'ASIN,登録日,商品名,Category(英・日),フォーム(自動・手動),材料(自動・手動),メーカー,メーカー住所,HSコード,Lithium,Cable,Video,Tsca,Lacey,Watch,TscaLacey,Clock,Radec\n';
      let ids = ['asin', 'registeredDate', 'productName', 'category', 'form', 'material', 'dmakerName', 'makerAddress', 'dhscode', 'includeLithiumBattery', 'markCable', 'markVideo', 'markTsca', 'markLacey', 'markWatch', 'markTscaLacey', 'markClock', 'markRadec'];
      this.outputFile(this.items, header, ids, 'Invoice_product.csv');
    },
    outputFile(items, header, ids, fileName) {
      let csv = header;
      for (const item of items) {
        csv = csv + '"';
        for (const id of ids) {
          if(id === 'category'){
            csv += item['dcategoryName'] + '|' + item['dcategoryNameJp'] + '","';
          } else if(id === 'form'){
            csv += item['dformAutoName'] + '|' + item['dformManualName'] + '","';
          } else if(id === 'material'){
            csv += item['dmaterialAutoName'] + '|' + item['dmaterialManualName'] + '","';
          } else{
            if(item[id] == null){
              csv += '","';
            } else{
              csv += item[id] + '","';
            }
          }
        }
        csv = csv.substring(0, csv.length - 2);
        csv += '\n';
      }
      const blob = new Blob([csv], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    getStatusList(item) {
      return item['statusList'];
    },
    handleOk() {
      api.updateInvoiceProductMaster(null, this.asinFilter, this.formFilter, this.materialFilter, this.invoiceCategoryId, this.makerId, this.statusFilter, this.editItem, (data) => {
        this.items = data.productMasterList;
        this.recordCount = this.items.length;
        this.addCellVariant(this.items);
        this.confirmMessageOkOnly = '登録完了しました。';
        this.$refs.confirmMessage.show();
      });
    },
    deleteRowConfirm(row) {
      Object.assign(this.editItem , row.item);
      this.confirmMessage = '削除しますか？';
      this.$refs.deleteRowConfirm.show();
    },
    deleteRow() {
      api.deleteInvoiceProductMaster(this.asinFilter, this.formFilter, this.materialFilter, this.invoiceCategoryId, this.makerId, this.statusFilter, this.editItem, (data) => {
        this.items = data.productMasterList;
        this.recordCount = this.items.length;
        this.addCellVariant(this.items);
        this.confirmMessageOkOnly = '削除完了しました。';
        this.$refs.confirmMessage.show();
      });
    },
    // getStatusList(item) {
    //   return item['statusList'];
    // },
    addCellVariant(items) {
      for (const v of items) {
        const errorCells = [];
        let isError = false;
        // let statusList = [];

        if (v['isErrorCategory']) {
          errorCells['category'] = 'danger';
          errorCells['dhscode'] = 'danger';
          errorCells['dcustomRate'] = 'danger';
          errorCells['material'] = 'danger';
          isError = true;
        }
        if (v['isErrorMaker']) {
          errorCells['makerAddress'] = 'danger';
          isError = true;
        }
        if (v['isErrorMaterial']) {
          errorCells['material'] = 'danger';
          isError = true;
        }
        if (isError) {
          errorCells['status'] = 'danger';
        }
        v['isError'] = isError;

        this.convertMark(v, 'markCable', errorCells);
        this.convertMark(v, 'markVideo', errorCells);
        this.convertMark(v, 'markTsca', errorCells);
        this.convertMark(v, 'markLacey', errorCells);
        this.convertMark(v, 'markWatch', errorCells);
        this.convertMark(v, 'markTscaLacey', errorCells);
        this.convertMark(v, 'markClock', errorCells);
        this.convertMark(v, 'markRadec', errorCells);
        this.convertMark(v, 'markDrop', errorCells);
        v['_cellVariants'] = errorCells;
      }
    },
    convertMark(v, markStr, errorCells) {
      if (v[markStr]) {
        errorCells[markStr] = 'secondary';
        v[markStr] = '●';
      } else{
        v[markStr] = '-';
      }
    }
  },
};

Vue.component('category-search', SearchCategory);
Vue.component('maker-search', SearchMaker);
Vue.component('material-search', SearchMaterial);
Vue.component('database-filter', DatabaseFilter);

</script>
<style>

.image {
  align-content: center;
}
table > thead > tr > th {
  text-align: center!important;
}
table label{
  margin-bottom: 0;
}
table .image{
  height: 3rem;
  width: 3rem;
}
.component-margin {
  margin-bottom: 1rem;
}
th.table-base {
  background-color: aliceblue!important;
}
td.table-success{
  background-color: rgba(40,167,69,.25);
}
td.table-warning{
  background-color: #ffeeba59;
}
.check-mark .custom-control-input:disabled:checked~.custom-control-label:before {
    background-color: #ff0000cf;
}
.mark {
    border-radius: 0.5rem;
    font-size: 0.8rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
}
.bkcolor-red{
    background-color: red;
    color: white;
}
.bkcolor-yellow{
    background-color: yellow;
    color: black;
}
.bkcolor-orange{
    background-color: lightsalmon;
    color: black;
}
.bkcolor-green{
    background-color: lightgreen;
    color: black;
}
.bkcolor-blue{
    background-color: skyblue;
    color: black;
}
.bkcolor-darkblue{
    background-color: blue;
    color: white;
}
.bkcolor-dark{
    background-color: darkgray;
    color: black;
}
.text-window {
    padding: 1em;
    background-color: lightblue;
}
.matome-status-mark .custom-control-input:disabled:checked~.custom-control-label:before {
    background-color: #ff0000cf;
}

@media (min-width: 768px) {
  .table-label { margin-top: 0.3rem; margin-bottom: 0.3rem; }
  .table-linput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: left; }
  .table-rinput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: right; }
  .table-lw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:left; }
  .table-lw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:left; }
  .table-lw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:left; }
  .table-lw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:left; }
  .table-lw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:left; }
  .table-lw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:left; }
  .table-lw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:left; }
  .table-lw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:left; }
  .table-lw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:left; }
  .table-lw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:left; }
  .table-lw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:left; }
  .table-lw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:left; }
  .table-lw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:left; }
  .table-lw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:left; }
  .table-lw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:left; }
  .table-lw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:left; }
  .table-lw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:left; }
  .table-lw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:left; }
  .table-lw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:left; }
  .table-rw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:right; }
  .table-rw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:right; }
  .table-rw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:right; }
  .table-rw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:right; }
  .table-rw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:right; }
  .table-rw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:right; }
  .table-rw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:right; }
  .table-rw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:right; }
  .table-rw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:right; }
  .table-rw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:right; }
  .table-rw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:right; }
  .table-rw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:right; }
  .table-rw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:right; }
  .table-rw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:right; }
  .table-rw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:right; }
  .table-rw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:right; }
  .table-rw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:right; }
  .table-rw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:right; }
  .table-rw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:right; }
  .table-cw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:center; }
  .table-cw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:center; }
  .table-cw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:center; }
  .table-cw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:center; }
  .table-cw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:center; }
  .table-cw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:center; }
  .table-cw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:center; }
  .table-cw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:center; }
  .table-cw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:center; }
  .table-cw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:center; }
  .table-cw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:center; }
  .table-cw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:center; }
  .table-cw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:center; }
  .table-cw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:center; }
  .table-cw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:center; }
  .table-cw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:center; }
  .table-cw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:center; }
  .table-cw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:center; }
  .table-cw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:center; }
}
</style>
